$( document ).ready(function() {
    jQuery('#request_sample_link').on('click', function(event) {
		event.preventDefault();
		jQuery('#custom-popup-overlay').fadeIn();
	});
    
    jQuery('.custom-close').on('click', function(event) {
		event.preventDefault();
		jQuery('#custom-popup-overlay').fadeOut();
	});
  
  /*--------- Get Success message form URL ----------*/
  jQuery.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURI(results[1]) || 0;
	}
  
  if(jQuery.urlParam('contact_posted')){
  	console.log(jQuery.urlParam('contact_posted'));
    jQuery('.popup_success_msg').html("Thanks for contacting us! We'll get back to you as soon as possible.");
  }
  /*--------- Get Success message form URL ----------*/
  
  /*----------------*/
  /*function submit_contact_form(){
    var form_action = $("#contact-form").attr('action');
	var form_data = $("#contact-form").serialize();

    $("#contact-form").submit(function() {
        $.ajax({
            url: form_action,
            dataType: 'json',
            data: form_data,
            type: 'GET',
            success: function(data) {
                alert(data);
            },
            error: function(xhr, textStatus, errorThrown) {
                alert(textStatus+': '+errorThrown);
            }

        });

        return false;
    });
  }*/
  /*----------------*/
  
});